import { render, staticRenderFns } from "./VideoInstruction.vue?vue&type=template&id=340b5f78&scoped=true&"
import script from "./VideoInstruction.vue?vue&type=script&lang=js&"
export * from "./VideoInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340b5f78",
  null
  
)

export default component.exports